import React from "react";
import { Container } from "react-bootstrap";

function ContactUs() {
    return (
        <Container className="empty-height">
            <h1>Welcome to ContactUs Page</h1>
        </Container>
    );
}

export default ContactUs;
